import axios from "axios";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { baseURL, basics } from "../../../basics";
import Loading from "../../Ui/Loading";
import SpecialItem from "./SpecialItem";
import { categoryActions } from "../../../store/category-slice";
import SwiperListOfSpecialProductsLayout from "../../Ui/swiperLayouts/SwipeListOfSpecialProductsLayout";
import { HiSparkles } from "react-icons/hi";

const ListOfSpecialProducts = (props: any) => {
  const [dataProduct, setDataProduct] = useState([""]);
  const [response, setResponse] = useState(false);
  //console.log("dataProduct", dataProduct);
  //console.log("props.id", props.id);
  useEffect(() => {
    axios({
      method: "get",
      url: `${baseURL}api/Product/GetSpecialProducts?PageNumber=${1}&RowCount=${15}`,
      responseType: "stream",
    })
      .then(function (response) {
        const data = response.data.data;
        setDataProduct(data);
        setResponse(true);
        //console.log("categoryUrl:response.specialsdata", response);
        //console.log("categoryUrl:data", data);
      })
      .catch(function (error: any) {
        //console.log("errorLIST", error);
      });
  }, []);
  const itemsPerPage = useSelector((state: any) => state.category.itemsPerPage);
  const currentPage = useSelector((state: any) => state.category.page);
  const dispatch = useDispatch();
  const history = useHistory();
  const catagorySelectedId = (id: any) => {
    dispatch(categoryActions.newCategoryIsSelected());
    dispatch(categoryActions.typeOfProductsCategoriesChanger("special"));
    // dispatch(fetchShowSpecialsHandler(currentPage, itemsPerPage));
    // dispatch(categoryActions.newCategoryIsSelected(id));
    // console.log("id", id);
    history.push("/products");
  };
  const specialProductsCodeColor = useSelector(
    (state: any) => state.shopInfo.shopInfoData.specialProductsCodeColor
  );

  if (!response) {
    return (
      <div className="my-24 mx-auto">
        <Loading />
      </div>
    );
  }
  return (
    <div className={`bg-[${specialProductsCodeColor}] max-w-[1400px] mx-auto`}>
      <div className={`mb-4 mx-auto text-center pt-6 sm:pt-8`}>
        <div className="flex justify-between items-center px-3 sm:px-4">
          <div className="flex justify-start items-center gap-1.5">
            <HiSparkles className="w-5 h-5 sm:w-6 sm:h-6 text-emerald-500" />
            <h2 className="text-lg sm:text-xl font-bold text-gray-900">
              {basics.specialOrderTitle}
            </h2>
          </div>
          <button
            onClick={catagorySelectedId}
            className="text-emerald-700 hover:text-emerald-800 text-sm sm:text-base font-medium transition"
          >
            {basics.seeAllProducts}
          </button>
        </div>
        <SwiperListOfSpecialProductsLayout
          data={dataProduct}
          navColor={specialProductsCodeColor}
        />
        {/* <div className="col-span-5 flex overflow-x-scroll ml-2 "> */}
        {/* {dataProduct.map((product: any) => (
          <SpecialItem
            key={product.id}
            items={product}
            colorCode={product.colorCode}
          />
        ))} */}
        {/* </div> */}
      </div>
    </div>
  );
};
export default ListOfSpecialProducts;
